module.exports = __webpack_public_path__ + "d7222c2b75c12540a3af8ccaca494b7e.png";